import script from "./BestSellersView.vue?vue&type=script&setup=true&lang=js"
export * from "./BestSellersView.vue?vue&type=script&setup=true&lang=js"

import "./BestSellersView.vue?vue&type=style&index=0&id=59d591ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d591ae"]])

export default __exports__